import {
	reactive,
	computed
} from 'vue';
import request from '@/utils/request';

const state = reactive({
	sidebar: [],
	popupList: [],
	popupFreq: 2,
	personalCenterWeb: [],
	personalCenterMobile: [],
	tabbar: [],
	jackpotConfig: {},
	scrollingConfig: {},
	vendorConfig: [],
	gameTypeConfig: [],
	appGameSecondary: [],
	appGameCarousel: [],
	appGameCarouselCasinoTwo: [],
	customerService:null,
	footer: null,
	loaded: false,
	loading: false,

});

const visibleKeys = computed(() =>
	new Set(state.sidebar.map(i => i.funcKey))
);

const orderMap = computed(() => {
	const m = {};
	state.sidebar.forEach(i => {
		m[i.funcKey] = i.sortOrder;
	});
	return m;
});

function isVisible(key) {
	return !state.loaded || visibleKeys.value.has(key);
}

function getOrder(key) {
	return orderMap.value[key] ?? 99;
}

async function fetchClientConfig() {
	if (state.loading) return;
	state.loading = true;
	try {
		const res = await request({
			url: '/app/clientConfig',
			method: 'get',
			headers: {
				skipToken: true
			}
		});
		if (res.data) {
			state.sidebar = res.data.sidebar || [];
			state.popupList = res.data.popupList || [];
			state.popupFreq = res.data.popupFreq ?? 2;
			state.personalCenterWeb = res.data.personalCenterWeb || [];
			state.personalCenterMobile = res.data.personalCenterMobile || [];
			state.tabbar = res.data.tabbar || [];
			state.customerService = res.data.customerService || null;
			state.footer = res.data.footer || null;
			state.jackpotConfig = res.data.jackpotConfig || {};
			state.scrollingConfig = res.data.scrollingConfig || {};
			state.vendorConfig = res.data.vendorConfig || [];
			state.gameTypeConfig = res.data.gameTypeConfig || [];
			state.appGameSecondary = res.data.appGameSecondary || [];
			state.appGameCarousel = res.data.appGameCarousel || [];
			state.appGameCarouselCasinoTwo = res.data.appGameCarouselCasinoTwo || [];
			state.loaded = true;
		
		}
	} catch (e) {
		console.error('[clientConfig] fetch failed', e);
	} finally {
		state.loading = false;
	}
}

function applyConfig(config) {
	if (config) {
		if (config.sidebar) {
			state.sidebar = config.sidebar;
		}
		if (config.popupList) {
			state.popupList = config.popupList;
		}
		if (config.popupFreq != null) {
			state.popupFreq = config.popupFreq;
		}
		if (config.personalCenterWeb) {
			state.personalCenterWeb = config.personalCenterWeb;
		}
		if (config.personalCenterMobile) {
			state.personalCenterMobile = config.personalCenterMobile;
		}
		if (config.tabbar) {
			state.tabbar = config.tabbar;
		}
		
		if (config.jackpotConfig != null) {
			state.jackpotConfig = config.jackpotConfig;
		}
		if (config.scrollingConfig != null) {
			state.scrollingConfig = config.scrollingConfig;
		}
		if (config.vendorConfig != null) {
			state.vendorConfig = config.vendorConfig;
		}
		if (config.gameTypeConfig != null) {
			state.gameTypeConfig = config.gameTypeConfig;
		}
		
		if (config.gameTypeConfig != null) {
			state.gameTypeConfig = config.gameTypeConfig;
		}
		
		if (config.appGameSecondary != null) {
			state.appGameSecondary = config.appGameSecondary;
		}
		
		if (config.appGameCarousel != null) {
			state.appGameCarousel = config.appGameCarousel;
		}
		
		if (config.appGameCarouselCasinoTwo != null) {
			state.appGameCarouselCasinoTwo = config.appGameCarouselCasinoTwo;
		}
		if ('footer' in config) {
			state.footer = config.footer;
		}
		if (config.customerService != null) {
			state.customerService = config.customerService;
		}
		state.loaded = true;
	}
}

function onSseConfigUpdated(e) {
	try {
		const config = typeof e.detail === 'string' ? JSON.parse(e.detail) : e.detail;
		applyConfig(config);
	} catch (err) {
		console.warn('[clientConfig] SSE data parse failed, fallback to fetch', err);
		fetchClientConfig();
	}
}

let listenerAttached = false;

function initClientConfig() {
	if (!listenerAttached) {
		window.addEventListener('sse:configUpdated', onSseConfigUpdated);
		listenerAttached = true;
	}
	if (!state.loaded) {
		fetchClientConfig();
	}
}

export function useClientConfig() {
	return {
		isVisible,
		getOrder,
		popupList: computed(() => state.popupList),
		popupFreq: computed(() => state.popupFreq),
		personalCenterWeb: computed(() => state.personalCenterWeb),
		personalCenterMobile: computed(() => state.personalCenterMobile),
		tabbar: computed(() => state.tabbar),
		customerService: computed(() => state.customerService),
		footer: computed(() => state.footer),
		configLoaded: computed(() => state.loaded),
		jackpotConfig: computed(() => state.jackpotConfig),
		scrollingConfig: computed(() => state.scrollingConfig),
		vendorConfig: computed(() => state.vendorConfig),
		gameTypeConfig: computed(() => state.gameTypeConfig),
		appGameSecondary: computed(() => state.appGameSecondary),
		appGameCarousel: computed(() => state.appGameCarousel),
		appGameCarouselCasinoTwo: computed(() => state.appGameCarouselCasinoTwo),
		fetchClientConfig,
		initClientConfig,


	};
}